import { email, required } from "./field-rules";

export default [
  {
    name: "email",
    attrs: {
      type: "email",
      label: "Новый email",
      required: true
    },
    rules: [required, email]
  }
];
